import React from 'react';
import { ColoredButton } from "packages/components";
import { Tab } from "packages/components/lib/Keyboard/Tab";
import Translator from "src/requests/apa/Translator";
import FlagEventMini from '../PersistentMiniEpg/FlagEventMini';

export const NotificationMessage = ({ message = '', renderMessage = null, buttons = [] }) => {
    const messageToDisplay = typeof renderMessage === 'function' ? renderMessage() : (<span className="app-notification-message-text">{message}</span>) ;
    return(
        <div className="app-notification-message-wrapper">
            {
                messageToDisplay
            }
            &emsp;
            <span className="app-notification-message-buttons">
                {
                    buttons.map( (button, i )=> {
                        const id = i ===0 ? 'notification-shortcut-button': null;
                        const { onClick = ()=>{}, color, label } = button;
                        return (
                            <Tab className="focusable" id={id} onClick={onClick}>
                                <ColoredButton color={color}>
                                    {label}
                                </ColoredButton>
                            </Tab>
                        )
                    })
                }
            </span>
        </div>
    )
}

export const FavoritedNotificationMessage = ({handleYellowPress = ()=>{}, closeNotification=()=>{}}) => {
    const buttons = [
        {
            onClick: ()=>{
                handleYellowPress();
                closeNotification();
            },
            color: 'yellow',
            label: Translator.get('recording_alert_option_button_myContents','MIS CONTENIDOS')
        }
    ];
    const message = Translator.get(
        'addFavorites_alert_description_label',
        'El canal fue añadido a la sección'
    );
    return(
        <NotificationMessage message={message} buttons={buttons}/>
    )
}

export const EventReminderNotificationMessage = ({ event, handleRedPress = ()=>{}, handleGreenPress = ()=>{}, closeNotification = ()=>{} }) => {
    const buttons = [
        {
            onClick: ()=>{
                handleRedPress();
                closeNotification();
            },
            color: 'red',
            label: Translator.get('reminder_alert_option_button_tuneinPlay','SINTONIZAR')
        },
        {
            onClick: ()=>{
                handleGreenPress();
                closeNotification();
            },
            color: 'green',
            label: Translator.get('reminder_alert_option_button_close','CERRAR')
        }
    ];
    const { channelNumber = '', channelImage = '', schedule = '' } = event ;
    const renderMessage = () => {
        return(
            <div className="app-notification-message-event-reminder">
                <span className="app-notification-message-event-reminder-channel-number"> {channelNumber} </span>
                <img className="app-notification-message-event-reminder-channel-image" alt="chanel" src={channelImage}/>
                <span className="app-notification-message-event-reminder-schedule">{schedule}</span>
            </div>
        );
    }
    return(
        <NotificationMessage renderMessage={renderMessage} buttons={buttons}/>
    )
}

export const FutureEventNotAvailableNotificationMessage = ({handleBluePress = ()=>{}, closeNotification =()=>{}}) => {
    const buttons = [
        {
            onClick: ()=>{
                handleBluePress();
                closeNotification();
                if(FlagEventMini.getFromNot()){
                    FlagEventMini.setFromNot(false);
                }
            },
            color: 'blue',
            label: Translator.get('timeshift_alert_option_button_menuOptions','MÁS OPCIONES')
        }
    ];

    const message = Translator.get("timeshift_alert_description_not_available_futureEvent_label","Este contenido  se transmitirá pronto");
    return(
        <NotificationMessage message={message} buttons={buttons}/>
    )
}



// WEBPACK FOOTER //
// ./src/components/Notification/CustomNotificationMessage.jsx